module.exports = __webpack_public_path__ + "img/azerbaijan.e9dc94be.svg";